import { useState, useEffect } from 'react';

const useFooterData = () => {
  const [footerData, setFooterData] = useState(null);
  const [loadingFooter, setLoading] = useState(true);
  const [errorFooter, setError] = useState(null);

  useEffect(() => {
    const fetchFooterData = async () => {
      try {
         const response = await fetch("https://backend.nuhababy.com/footer");
        if (!response.ok) {
          throw new Error('Failed to fetch footer data');
        }
        const data = await response.json();
        setFooterData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFooterData();
  }, []);

  return { footerData, loadingFooter, errorFooter };
};

export default useFooterData;
